import React from "react";
import Moment from "react-moment";
import { Clock, Key, FileText, Smartphone, UserCog } from "lucide-react";
import "./ViewRole.css";

const sectionTitleStyle = {
  fontSize: "12px",
  fontWeight: 700,
  color: "#94A3B8",
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  borderBottom: "1px solid #EEF2F6",
  paddingBottom: "8px",
  marginBottom: "14px",
};

const labelStyle = {
  display: "block",
  fontSize: "12px",
  fontWeight: 700,
  color: "#2E6DA4",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  marginBottom: "4px",
};

const valueStyle = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#0F2D42",
  lineHeight: 1.5,
};

const fieldGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
  gap: "18px",
};

const RoleInfo = ({ roleData, webPermissionNames, mobilePermissionNames }) => {
  if (!roleData) {
    return (
      <div className="rov-page">
        <div className="rov-card rov-empty">No role data available.</div>
      </div>
    );
  }

  return (
    <div className="rov-page">
      <div className="rov-card rov-card-body" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {/* ── Basic Information ── */}
        <div>
          <div style={sectionTitleStyle}>Basic Information</div>
          <div style={fieldGridStyle}>
            <div>
              <label style={labelStyle}>Role Name</label>
              <div style={valueStyle}>{roleData.name || "NA"}</div>
            </div>
            <div>
              <label style={labelStyle}>
                <Clock size={11} style={{ marginRight: "4px", verticalAlign: "-1px" }} />
                Created On
              </label>
              <div style={valueStyle}>
                {roleData.createdOn ? (
                  <Moment format="DD-MM-YYYY, hh:mm A">{roleData.createdOn}</Moment>
                ) : (
                  "NA"
                )}
              </div>
            </div>
            <div>
              <label style={labelStyle}>
                <Clock size={11} style={{ marginRight: "4px", verticalAlign: "-1px" }} />
                Updated On
              </label>
              <div style={valueStyle}>
                {roleData.updatedOn ? (
                  <Moment format="DD-MM-YYYY, hh:mm A">{roleData.updatedOn}</Moment>
                ) : (
                  "NA"
                )}
              </div>
            </div>
            <div>
              <label style={labelStyle}>
                <UserCog size={11} style={{ marginRight: "4px", verticalAlign: "-1px" }} />
                Created By
              </label>
              <div style={valueStyle}>{roleData.createdByName || "NA"}</div>
            </div>
            <div>
              <label style={labelStyle}>
                <UserCog size={11} style={{ marginRight: "4px", verticalAlign: "-1px" }} />
                Updated By
              </label>
              <div style={valueStyle}>{roleData.updatedByName || "NA"}</div>
            </div>
          </div>
        </div>

        {/* ── Permission ── */}
        <div>
          <div style={sectionTitleStyle}>Permission</div>
          <div style={fieldGridStyle}>
            <div>
              <label style={labelStyle}>
                <Key size={11} style={{ marginRight: "4px", verticalAlign: "-1px" }} />
                Web Permission
              </label>
              <div style={valueStyle}>{webPermissionNames || "NA"}</div>
            </div>
            <div>
              <label style={labelStyle}>
                <Smartphone size={11} style={{ marginRight: "4px", verticalAlign: "-1px" }} />
                Mobile Permission
              </label>
              <div style={valueStyle}>{mobilePermissionNames || "NA"}</div>
            </div>
          </div>
        </div>

        {/* ── Description ── */}
        <div>
          <div style={sectionTitleStyle}>
            <FileText size={11} style={{ marginRight: "4px", verticalAlign: "-1px" }} />
            Description
          </div>
          <div
            style={{
              ...valueStyle,
              fontWeight: 500,
              background: "#EBF4FA",
              border: "1px solid #E2E8F0",
              borderRadius: "10px",
              padding: "12px 14px",
            }}
          >
            {roleData.description || "NA"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleInfo;
